// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"6429db31","453":"0e96be40"}[chunkId] + ".chunk.js";
};